import ProductivityByAttorney from './ProductivityByAttorney';

export default ProductivityByAttorney;
